import { useMemo } from 'react'
import { PolicyEvaluationResult } from '../components/PolicyBanner/types'

export function usePolicyEvaluation(intakePolicyEvaluation: PolicyEvaluationResult | null): {
  policyEvaluation: PolicyEvaluationResult | null
  canSubmitApplication: boolean
} {
  return useMemo(() => {
    if (!intakePolicyEvaluation) {
      return {
        policyEvaluation: null,
        canSubmitApplication: true, // Allow if no policy evaluation
      }
    }

    const hasMaxActiveApplicationsViolation =
      intakePolicyEvaluation.violations?.some(
        violation => violation.code === 'MAX_ACTIVE_APPLICATIONS_EXCEEDED',
      ) ?? false

    return {
      policyEvaluation: intakePolicyEvaluation,
      canSubmitApplication: !hasMaxActiveApplicationsViolation,
    }
  }, [intakePolicyEvaluation])
}
